export enum UserRoleEnums {
  'Admin'='admin',
  'Customer'='customer',
  'Provider' = 'provider'
}
